import { BatteryType } from "@/enums/Battery/BatteryType";
import Requests from "@/services/Requests";

const variants = [
  "danger",
  "info",
  "success",
  "warning",
  "primary",
  "secondary",
];
var batteryArray = Object.keys(BatteryType);

export const getBatteryType = (value) => {
  const index = batteryArray.findIndex((e) => e === value); // 0
  if (index > -1) {
    const item = index % variants.length;
    return {
      key: value,
      variant: variants[item],
      name: BatteryType[value],
      startsWith: BatteryType[value][0],
    };
  }
  return {
    key: value,
    variant: "danger",
    name: BatteryType[value],
    startsWith: "",
  };
};

/**
 * Returns an array of objects containing the key, variant, name, and startsWith
 * properties for each battery type. The variant is derived from the index of
 * the battery type in the variants array.
 *
 * @returns {Array<{key: string, variant: string, name: string, startsWith: string}>}
 */
export const getBatteryTypes = () => {
  return batteryArray.map((b, i) => ({
    key: b,
    variant: variants[i % variants.length],
    name: BatteryType[b],
    startsWith: BatteryType[b][0],
  }));
};

const eveporatorRequestBody = {
  type: "Evaporator",
  name: "string",
  dimensions: {
    length: 0,
    tubeCount: 0,
    rowCount: 0,
    noOfCircuit: 0,
//    passCount: 0,
  },
  generalFeatures: {
    geometryId: 0,
    tubeMaterialId: 0,
    finMaterialId: 0,
    finPitchId: 0,
    tubeThicknessId: 0,
    finThicknessId: 0,
  },
  refrigerantFeatures: {
    refrigerantId: 0,
    evaporatorTemp: 0,
    condenserTemp: 0,
    superheat: 0,
    subcooling: 0,
    fanFlow: 0,
    airInletTemp: 0,
    airInletHumidity: 0,
    atmospherePressure: 0,
    wetBulbInlet: 0,
  },
  calculateResult: {
    capacity: 0,
    airPressureDrop: 0,
    airTemperatureWetbulbOutlet: 0,
    airTemperatureOutlet: 0,
    airVelocityOutlet: 0,
    airHumidityOutlet: 0,
    passCount: 0,
    lDmax: 0,
    hr: 0,
    lh: 0,
    th: 0,
    fldPressureDrop: 0,
    fldMassFlow: 0,
    condensatedFlow: 0,
    fldPressureDropKelvin: 0,
    capacitySensible: 0,
    capacityRatio: 0,
  },
};

const condenserRequestBody = {
  type: "Evaporator",
  name: "string",
  dimensions: {
    length: 0,
    tubeCount: 0,
    rowCount: 0,
    noOfCircuit: 0,
    passCount: 0,
  },
  generalFeatures: {
    geometryId: 0,
    tubeMaterialId: 0,
    finMaterialId: 0,
    finPitchId: 0,
    tubeThicknessId: 0,
    finThicknessId: 0,
  },
  refrigerantFeatures: {
    refrigerantId: 0,
    evaporatorTemp: 0,
    condenserTemp: 0,
    superheat: 0,
    subcooling: 0,
    fanFlow: 0,
    airInletTemp: 0,
    airInletHumidity: 0,
    atmospherePressure: 0,
    wetBulbInlet: 0,
  },
  calculateResult: {
    capacity: 0,
    airPressureDrop: 0,
    airTemperatureWetbulbOutlet: 0,
    airTemperatureOutlet: 0,
    airVelocityOutlet: 0,
    airHumidityOutlet: 0,
    passCount: 0,
    lDmax: 0,
    hr: 0,
    lh: 0,
    th: 0,
    fldPressureDrop: 0,
    fldMassFlow: 0,
    condensatedFlow: 0,
    fldPressureDropKelvin: 0,
    capacitySensible: 0,
    capacityRatio: 0,
  },
};

const batteryBodies = {
  Evaporator: {
    body: eveporatorRequestBody,
    calculateRequest: Requests.Battery.CalculateEvaporatorBattery,
  },
  Condenser: {
    body: condenserRequestBody,
    calculateRequest: Requests.Battery.CalculateCondenserBattery,
  },
};

/**
 * Prepare the request body for the given battery type and its features.
 * @param {'Evaporator' | 'Condenser'} type - The type of the battery. Currently supported types are "Evaporator" and "Condenser".
 * @param {Array<eveporatorRequestBody | condenserRequestBody>} features - The features of the battery.
 * @returns {{calculateRequest: Function, body: eveporatorRequestBody | condenserRequestBody}} The request body for the given battery type.
 */
export const getBatteryRequestBodies = (type, features) => {
  const battery = batteryBodies[type];
  const body = battery.body;
  const featureList = features.map((f) => f.options).flat(1);
  for (const key in body) {
    if (Object.prototype.hasOwnProperty.call(body, key)) {
      for (const childKey in body[key]) {
        if (Object.prototype.hasOwnProperty.call(body[key], childKey)) {
          const bodyKey = featureList.find((f) => f.bodyKey === childKey);
          if (bodyKey) {
            if (bodyKey.type === "select")
              body[key][childKey] = bodyKey.value?.id || null;
            else body[key][childKey] = Number(bodyKey.value) || null;
          }
        }
      }
    }
  }
  return { body, calculateRequest: battery.calculateRequest };
};
